import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'RenderInput',
  props: ['item'],
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), null, 16))
}
}

})